import actions from './actions'

const weather = {
  state: null,
  mutations: null,
  actions
}

export default weather



// WEBPACK FOOTER //
// ./src/store/weather/index.js